import { faEllipsisVertical, faRotate, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { Badge, Dropdown, Table } from 'react-bootstrap'
import toast from 'react-hot-toast'
import AdminService from '../../services/admin.service'
import ResetPasswordModal from '../Modal/resetPassword.modal'
import CustomToggle from '../toggle/CustomToggle'

interface IProps {
    verificationClients: any,
    examId: any,
    reload: any
}

const VerificationClientTable = ({ verificationClients, examId, reload }: IProps) => {

    const [showResetModal, setShowResetModal] = useState<any>(undefined);

    const handleResetPassword = async (username: any) => {
        await AdminService.resetVerificationClientPassword(examId, username).then(res => {
            if (res.status === 200) {
                setShowResetModal(res.data);
                reload();
            }
        }).catch(err => {
            toast.error(err?.response?.data || "Failed to reset password");
        })
    }

    const handleToggleActive = async (id: any, currentStatus: boolean) => {
        await AdminService.setActiveVerificationClient(id, !currentStatus).then(res => {
            if (res.status === 200) {
                reload();
                toast.success(`Verification client ${!currentStatus ? 'activated' : 'deactivated'} successfully`);
            }
        }).catch(err => {
            toast.error(err?.response?.data || "Failed to update status");
        })
    }

    return (
        <>
            <Table striped hover className="xcn-text-12">
                <thead>
                    <tr>
                        <th>Sr.No</th>
                        <th><span className="fw-bold">Email</span></th>
                        <th><span className="fw-bold">Username</span></th>
                        <th><span className="fw-bold">Status</span></th>
                        <th><span className="fw-bold">Action</span></th>
                    </tr>
                </thead>
                <tbody>
                    {verificationClients && verificationClients.length > 0 ? verificationClients.map((vc: any, index: number) => {
                        return (
                            <tr key={vc._id}>
                                <td>{index + 1}</td>
                                <td>{vc.email || "N/A"}</td>
                                <td>{vc.username}</td>
                                <td>
                                    <Badge bg={vc.isActive !== false ? "success" : "secondary"}>
                                        {vc.isActive !== false ? "Active" : "Inactive"}
                                    </Badge>
                                </td>
                                <td>
                                    <Dropdown>
                                        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                            <FontAwesomeIcon icon={faEllipsisVertical} />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => handleResetPassword(vc.username)}>
                                                <FontAwesomeIcon icon={faRotate} className="text-primary me-2" />
                                                <span className="fw-bold">Reset Password</span>
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleToggleActive(vc._id, vc.isActive !== false)}>
                                                <FontAwesomeIcon icon={vc.isActive !== false ? faToggleOff : faToggleOn} className={`me-2 ${vc.isActive !== false ? 'text-danger' : 'text-success'}`} />
                                                <span className="fw-bold">
                                                    {vc.isActive !== false ? "Deactivate" : "Activate"}
                                                </span>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td>
                            </tr>
                        )
                    }) : <tr><td colSpan={5}>No verification clients found</td></tr>}
                </tbody>
            </Table>
            <ResetPasswordModal
                show={showResetModal}
                handleClose={() => setShowResetModal(false)}
            />
        </>
    )
}

export default VerificationClientTable
